<div class="container p-0 pr-0 pl-0">
  <div class="step-control-cont">
    <lib-lang-droplist
      *ngIf="langDropdown && !closeBut"
      class="lang-switcher"
      [noNative]="true"
      [dropdownIconsPath]="'/icons/icon-arrow-b-'"
      [triggerIcon]="'/icons/translate-icon.svg'"
    ></lib-lang-droplist>
    <div class="close-cont" *ngIf="closeBut === true" (click)="close()">
      <img src="/assets/icons/close-icon.svg" />
    </div>
  </div>

  <div class="progress-cont" *ngIf="withProgress && steps && currentStep !== null && currentStep !== undefined">
    <div class="progress-line" [style.width.%]="progresNum"></div>
  </div>
</div>
